// IT / EN translations dictionary
const translations = {
  it: {
    meta: {
      title: "Food & Beverage Services S.R.L. — Importazione internazionale food & beverage",
      description:
        "Importatore e distributore B2B di bevande, snack dolci e salati. Servizi di import su misura per aziende, HORECA, retail e distributori.",
    },
    nav: {
      home: "Home",
      about: "Chi siamo",
      services: "Servizi",
      products: "Prodotti",
      markets: "Mercati",
      news: "Notizie",
      faq: "FAQ",
      quote: "Preventivo",
      contact: "Contatti",
      requestQuote: "Richiedi preventivo",
    },
    hero: {
      eyebrow: "Commercio internazionale Food & Beverage",
      title: "Eccellenze alimentari, portate al vostro mercato.",
      subtitle:
        "Importiamo e distribuiamo bevande, snack dolci e salati di marca per aziende, distributori e catene retail in tutto il mondo. Sourcing su misura, logistica gestita, qualità garantita.",
      ctaQuote: "Richiedi un preventivo",
      ctaCatalog: "Esplora il catalogo",
      stat1: "Paesi serviti",
      stat2: "Brand in portafoglio",
      stat3: "Anni di esperienza",
    },
    about: {
      eyebrow: "Chi siamo",
      title: "Un partner solido per il vostro business internazionale.",
      paragraph1:
        "Food & Beverage Services S.R.L. è specializzata nel commercio internazionale di prodotti alimentari e bevande. Operiamo come ponte tra produttori, distributori e buyer professionali, semplificando ogni passaggio: dalla selezione del prodotto alla consegna finale.",
      paragraph2:
        "Lavoriamo esclusivamente B2B con aziende, importatori, HORECA, GDO, duty-free e operatori del retail. La nostra promessa: prodotti autentici, prezzi competitivi, processi trasparenti.",
      bullet1: "Selezione rigorosa di brand premium e mass-market",
      bullet2: "Documentazione doganale completa e certificata",
      bullet3: "Spedizioni full-container o consolidate",
      bullet4: "Referente commerciale dedicato",
    },
    services: {
      eyebrow: "I nostri servizi",
      title: "Tutto ciò che serve per importare con serenità.",
      items: [
        {
          title: "Sourcing su misura",
          desc: "Identifichiamo i prodotti giusti per il vostro mercato, lavorando direttamente con produttori e brand owner.",
        },
        {
          title: "Import & Export",
          desc: "Gestione completa di pratiche doganali, certificazioni e documentazione per spedizioni internazionali.",
        },
        {
          title: "Logistica integrata",
          desc: "Spedizioni via mare, terra e aria con consolidamento merce, tracciabilità end-to-end e magazzino temporaneo.",
        },
        {
          title: "Private label & distribuzione",
          desc: "Soluzioni a marchio proprio e distribuzione esclusiva per aree geografiche.",
        },
      ],
    },
    products: {
      eyebrow: "Catalogo prodotti",
      title: "Una selezione curata, senza compromessi.",
      subtitle:
        "Lavoriamo i brand più richiesti sul mercato globale. Listino completo e prezzi forniti su richiesta tramite preventivo dedicato.",
      tabs: {
        beverages: "Bibite",
        sweet: "Snack Dolci",
        salty: "Snack Salati",
      },
      searchPlaceholder: "Cerca un brand o prodotto…",
      empty: "Nessun prodotto trovato.",
      ctaQuote: "Richiedi preventivo per questa categoria",
      noPriceNotice: "Prezzi su richiesta — quotazioni personalizzate per volumi B2B.",
      andMore: "… e tanti altri prodotti tra i più venduti al mondo.",
    },
    markets: {
      eyebrow: "Mercati serviti",
      title: "Operiamo in 4 continenti.",
      subtitle:
        "Esperienza consolidata nei mercati EU, Medio Oriente, Africa, America Latina e Sud-est asiatico.",
      regions: [
        { name: "Unione Europea", desc: "Distribuzione capillare in 27 paesi UE." },
        { name: "Medio Oriente & Golfo", desc: "UAE, Arabia Saudita, Qatar, Kuwait, Bahrain." },
        { name: "Africa", desc: "Nord Africa e Africa Subsahariana." },
        { name: "America Latina", desc: "Brasile, Messico, Colombia, Cile." },
        { name: "Sud-est asiatico", desc: "Singapore, Vietnam, Filippine, Indonesia." },
        { name: "Duty Free Global", desc: "Travel retail e duty-free network." },
      ],
    },
    quote: {
      eyebrow: "Preventivo",
      title: "Richiedete un preventivo personalizzato.",
      subtitle:
        "Compilate il modulo: un nostro account manager vi risponderà entro 24 ore lavorative.",
      labels: {
        company: "Ragione sociale",
        contactName: "Nome e cognome",
        email: "Email aziendale",
        phone: "Telefono",
        country: "Paese di destinazione",
        categories: "Categorie di interesse",
        catBeverages: "Bibite",
        catSweet: "Snack dolci",
        catSalty: "Snack salati",
        catOther: "Altro / Misto",
        products: "Prodotti / brand richiesti",
        productsPlaceholder: "Es. Coca-Cola lattine 330ml, Pringles, Ferrero Rocher…",
        quantity: "Quantità stimata",
        quantityPlaceholder: "Es. 2 container 40' al mese",
        message: "Note aggiuntive",
        messagePlaceholder: "Indicate tempistiche, packaging richiesto, condizioni Incoterms…",
      },
      submit: "Invia richiesta",
      submitting: "Invio in corso…",
      success: "Richiesta inviata. Vi contatteremo entro 24h lavorative.",
      error: "Si è verificato un errore. Riprovate tra qualche minuto.",
      requiredHint: "* Campi obbligatori",
    },
    contact: {
      eyebrow: "Contatti",
      title: "Parliamone.",
      subtitle:
        "Per informazioni generali, partnership o stampa, scriveteci utilizzando il modulo qui sotto.",
      labels: {
        name: "Nome e cognome",
        email: "Email",
        company: "Azienda",
        phone: "Telefono",
        subject: "Oggetto",
        message: "Messaggio",
      },
      submit: "Invia messaggio",
      submitting: "Invio in corso…",
      success: "Messaggio inviato. Grazie per averci contattato.",
      error: "Si è verificato un errore. Riprovate tra qualche minuto.",
      infoTitle: "Informazioni di contatto",
      addresses: [
        { label: "Sede legale", value: "Via Macedonia, 135/BIS — 80049 Somma Vesuviana (NA)" },
        { label: "Sede logistica", value: "Via Campania, 11 — 80017 Melito di Napoli (NA)" },
        { label: "Logistica", value: "Via Luigi Pirandello, 13 — 80040 Volla (NA)" },
      ],
      phoneValue: "+39 377 579 8632",
      phoneNote: "Tel. & WhatsApp",
      emails: [
        { label: "CEO", value: "direzione@mondial-food.com" },
        { label: "Vendite", value: "sales@mondial-food.com" },
        { label: "Diventare fornitore", value: "buyer@mondial-food.com" },
        { label: "Informazioni generali", value: "info@mondial-food.com" },
      ],
      emailFooter: "info@mondial-food.com",
      hours: "Orari",
      hoursValue: "Lun–Ven 9:00 – 18:00 CET",
    },
    faq: {
      eyebrow: "Domande frequenti",
      title: "Tutto ciò che dovete sapere prima di iniziare.",
      items: [
        {
          q: "Lavorate solo con aziende?",
          a: "Sì. Operiamo esclusivamente B2B con importatori, distributori, GDO, HORECA, duty-free, retail e gestori di catene di vendita.",
        },
        {
          q: "Quali sono i quantitativi minimi d'ordine?",
          a: "Variano in base al prodotto, ma generalmente partiamo da un pallet completo per gli ordini consolidati e da un container 20' per ordini full-load.",
        },
        {
          q: "Gestite anche le pratiche doganali?",
          a: "Sì. Forniamo documentazione completa: fattura proforma, packing list, certificati di origine, EUR1, sanitari, halal, kosher e altri secondo destinazione.",
        },
        {
          q: "Quali Incoterms applicate?",
          a: "Lavoriamo con tutti gli Incoterms 2020: FOB, CIF, CFR, DAP, DDP, EXW. Indicate la vostra preferenza in fase di preventivo.",
        },
        {
          q: "Quanto tempo richiede una quotazione?",
          a: "Rispondiamo entro 24 ore lavorative dalla ricezione della richiesta completa.",
        },
        {
          q: "Offrite servizi private label?",
          a: "Sì. Possiamo proporvi produttori certificati per linee a marchio proprio in diverse categorie.",
        },
      ],
    },
    footer: {
      tagline: "Importatore B2B di prodotti food & beverage in tutto il mondo.",
      explore: "Esplora",
      legal: "Legale",
      privacy: "Privacy policy",
      terms: "Termini di servizio",
      cookie: "Cookie policy",
      contact: "Contatti",
      rights: "Tutti i diritti riservati.",
      pIva: "P.IVA IT04361480611",
    },
    news: {
      eyebrow: "Notizie commercio internazionale",
      title: "L'osservatorio settimanale del food & beverage globale.",
      subtitle:
        "Editoriale settimanale a cura di Food & Beverage Services S.R.L. — letture rapide su trend, dazi, logistica e opportunità di mercato. In coda, le notizie più rilevanti aggregate in tempo reale dalle principali testate.",
      featured: "Editoriale della settimana",
      archive: "Archivio editoriali",
      archiveEmpty: "L'archivio si popolerà nelle prossime settimane.",
      aggregated: "Notizie in tempo reale",
      aggregatedTitle: "Le ultime dal mondo del food & beverage.",
      source: "Fonte",
      readMore: "Leggi sulla fonte",
      noItems: "Nessuna notizia disponibile al momento.",
      refresh: "Aggiorna",
      loading: "Caricamento contenuti…",
      error: "Impossibile caricare le notizie. Riprovare più tardi.",
      editorialUnavailable: "Editoriale in preparazione. Tornate tra poco.",
      disclaimer:
        "Le notizie aggregate provengono da fonti terze tramite Google News. Food & Beverage Services S.R.L. non è responsabile dei contenuti pubblicati dalle testate originali.",
      ctaText: "Interessati a una di queste opportunità? Richiedete un preventivo personalizzato.",
    },
  },
  en: {
    meta: {
      title: "Food & Beverage Services S.R.L. — International food & beverage import",
      description:
        "B2B importer and distributor of beverages, sweet and salty snacks. Tailored import services for companies, HORECA, retail and distributors.",
    },
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      products: "Products",
      markets: "Markets",
      news: "News",
      faq: "FAQ",
      quote: "Quote",
      contact: "Contact",
      requestQuote: "Request quote",
    },
    hero: {
      eyebrow: "International Food & Beverage Trade",
      title: "Food excellence, delivered to your market.",
      subtitle:
        "We import and distribute branded beverages, sweet and salty snacks for companies, distributors and retail chains worldwide. Tailored sourcing, managed logistics, guaranteed quality.",
      ctaQuote: "Request a quote",
      ctaCatalog: "Explore the catalog",
      stat1: "Countries served",
      stat2: "Brands in portfolio",
      stat3: "Years of experience",
    },
    about: {
      eyebrow: "About us",
      title: "A reliable partner for your international business.",
      paragraph1:
        "Food & Beverage Services S.R.L. specialises in international trade of food and beverages. We act as a bridge between producers, distributors and professional buyers, simplifying every step: from product selection to final delivery.",
      paragraph2:
        "We work exclusively B2B with companies, importers, HORECA, retail chains, duty-free and travel-retail operators. Our promise: authentic products, competitive pricing, transparent processes.",
      bullet1: "Rigorous selection of premium and mass-market brands",
      bullet2: "Full certified customs documentation",
      bullet3: "Full-container or consolidated shipments",
      bullet4: "Dedicated commercial account manager",
    },
    services: {
      eyebrow: "Our services",
      title: "Everything you need to import with confidence.",
      items: [
        {
          title: "Tailored sourcing",
          desc: "We identify the right products for your market, working directly with manufacturers and brand owners.",
        },
        {
          title: "Import & Export",
          desc: "End-to-end management of customs, certifications and documentation for international shipments.",
        },
        {
          title: "Integrated logistics",
          desc: "Sea, land and air shipments with cargo consolidation, end-to-end tracking and temporary warehousing.",
        },
        {
          title: "Private label & distribution",
          desc: "Own-brand solutions and exclusive distribution agreements by geographic area.",
        },
      ],
    },
    products: {
      eyebrow: "Product catalog",
      title: "A curated selection, no compromises.",
      subtitle:
        "We trade the most requested brands on the global market. Full price list provided on request through a dedicated quotation.",
      tabs: {
        beverages: "Beverages",
        sweet: "Sweet Snacks",
        salty: "Salty Snacks",
      },
      searchPlaceholder: "Search brand or product…",
      empty: "No products found.",
      ctaQuote: "Request a quote for this category",
      noPriceNotice: "Prices on request — custom B2B volume quotations.",
      andMore: "… and many more of the best-selling products worldwide.",
    },
    markets: {
      eyebrow: "Markets we serve",
      title: "Operating across 4 continents.",
      subtitle:
        "Consolidated experience in EU, Middle East, Africa, Latin America and South-East Asia markets.",
      regions: [
        { name: "European Union", desc: "Capillary distribution across 27 EU countries." },
        { name: "Middle East & Gulf", desc: "UAE, Saudi Arabia, Qatar, Kuwait, Bahrain." },
        { name: "Africa", desc: "North and Sub-Saharan Africa." },
        { name: "Latin America", desc: "Brazil, Mexico, Colombia, Chile." },
        { name: "South-East Asia", desc: "Singapore, Vietnam, Philippines, Indonesia." },
        { name: "Global Duty Free", desc: "Travel retail and duty-free networks." },
      ],
    },
    quote: {
      eyebrow: "Quote",
      title: "Request a tailored quote.",
      subtitle:
        "Fill in the form: one of our account managers will reply within 24 business hours.",
      labels: {
        company: "Company name",
        contactName: "Full name",
        email: "Business email",
        phone: "Phone",
        country: "Destination country",
        categories: "Categories of interest",
        catBeverages: "Beverages",
        catSweet: "Sweet snacks",
        catSalty: "Salty snacks",
        catOther: "Other / Mixed",
        products: "Products / brands requested",
        productsPlaceholder: "E.g. Coca-Cola cans 330ml, Pringles, Ferrero Rocher…",
        quantity: "Estimated quantity",
        quantityPlaceholder: "E.g. 2 x 40' containers per month",
        message: "Additional notes",
        messagePlaceholder: "Lead time, packaging, Incoterms…",
      },
      submit: "Send request",
      submitting: "Sending…",
      success: "Request sent. We'll contact you within 24 business hours.",
      error: "An error occurred. Please try again in a few minutes.",
      requiredHint: "* Required fields",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk.",
      subtitle:
        "For general inquiries, partnerships or press, please write to us using the form below.",
      labels: {
        name: "Full name",
        email: "Email",
        company: "Company",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
      },
      submit: "Send message",
      submitting: "Sending…",
      success: "Message sent. Thank you for reaching out.",
      error: "An error occurred. Please try again in a few minutes.",
      infoTitle: "Contact information",
      addresses: [
        { label: "Registered office", value: "Via Macedonia, 135/BIS — 80049 Somma Vesuviana (NA), Italy" },
        { label: "Logistics hub", value: "Via Campania, 11 — 80017 Melito di Napoli (NA), Italy" },
        { label: "Logistics", value: "Via Luigi Pirandello, 13 — 80040 Volla (NA), Italy" },
      ],
      phoneValue: "+39 377 579 8632",
      phoneNote: "Phone & WhatsApp",
      emails: [
        { label: "CEO", value: "direzione@mondial-food.com" },
        { label: "Sales", value: "sales@mondial-food.com" },
        { label: "Become a supplier", value: "buyer@mondial-food.com" },
        { label: "General inquiries", value: "info@mondial-food.com" },
      ],
      emailFooter: "info@mondial-food.com",
      hours: "Hours",
      hoursValue: "Mon–Fri 9:00 – 18:00 CET",
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "Everything you need to know before getting started.",
      items: [
        {
          q: "Do you work only with companies?",
          a: "Yes. We operate exclusively B2B with importers, distributors, retail chains, HORECA, duty-free and travel retail operators.",
        },
        {
          q: "What are the minimum order quantities?",
          a: "They vary depending on the product, but generally start from one full pallet for consolidated orders and one 20' container for full-load orders.",
        },
        {
          q: "Do you handle customs procedures?",
          a: "Yes. We provide full documentation: proforma invoice, packing list, certificates of origin, EUR1, sanitary, halal, kosher and others based on destination.",
        },
        {
          q: "Which Incoterms do you use?",
          a: "We work with all Incoterms 2020: FOB, CIF, CFR, DAP, DDP, EXW. Specify your preference when requesting a quote.",
        },
        {
          q: "How long does a quotation take?",
          a: "We reply within 24 business hours from the receipt of a complete request.",
        },
        {
          q: "Do you offer private label services?",
          a: "Yes. We can connect you with certified manufacturers for own-brand lines across multiple categories.",
        },
      ],
    },
    footer: {
      tagline: "B2B food & beverage importer serving the global market.",
      explore: "Explore",
      legal: "Legal",
      privacy: "Privacy policy",
      terms: "Terms of service",
      cookie: "Cookie policy",
      contact: "Contact",
      rights: "All rights reserved.",
      pIva: "VAT IT04361480611",
    },
    news: {
      eyebrow: "International trade news",
      title: "The weekly observatory of the global food & beverage trade.",
      subtitle:
        "Weekly editorial by Food & Beverage Services S.R.L. — concise reads on trends, tariffs, logistics and market opportunities. Below, the most relevant headlines aggregated live from leading outlets.",
      featured: "This week's editorial",
      archive: "Editorial archive",
      archiveEmpty: "The archive will fill up over the coming weeks.",
      aggregated: "Live news",
      aggregatedTitle: "Latest from the food & beverage world.",
      source: "Source",
      readMore: "Read on source",
      noItems: "No news available at the moment.",
      refresh: "Refresh",
      loading: "Loading content…",
      error: "Unable to load the news. Please try again later.",
      editorialUnavailable: "Editorial in preparation. Please come back soon.",
      disclaimer:
        "Aggregated headlines come from third-party outlets via Google News. Food & Beverage Services S.R.L. is not responsible for content published by original publishers.",
      ctaText: "Interested in any of these opportunities? Request a tailored quote.",
    },
  },
};

export default translations;
